(function () {

  const RULES = {
    'black-distant-hoodie':          'black-distant-sweatpants',
    'pink-distant-hoodie':           'pink-distant-sweatpants',
    'blue-distant-hoodie':           'blue-distant-sweatpants',
    'purple-distant-hoodie':         'purple-distant-sweatpants',
    'black-distant-sweatpants':      'black-distant-hoodie',
    'pink-distant-sweatpants':       'pink-distant-hoodie',
    'blue-distant-sweatpants':       'blue-distant-hoodie',
    'purple-distant-sweatpants':     'purple-distant-hoodie',
    'black-distant-sweatpants-copy': 'black-distant-hoodie',
    'purple-distant-sweatpants-copy':'purple-distant-hoodie',
    'blue-distant-sweatpants-copy':  'blue-distant-hoodie',
    'pink-distant-sweats':           'pink-distant-hoodie',
    'black-tracksuit':               'black-distant-hoodie',
    'regards-tee':                   'blue-distant-jorts',
    'cassette-tee':                  'blue-distant-jorts',
    'distant-white-tee':             'blue-distant-jorts',
    'distant-black-tee':             'black-distant-jorts',
    'black-leave-me-alone-tee':      'black-distant-jorts',
    'white-leave-me-alone-tee':      'blue-distant-jorts',
    'conflicted-lovers-longsleeve':  'blue-distant-sweatpants',
    'blue-distant-jorts':            'distant-white-tee',
    'black-distant-jorts':           'distant-black-tee',
    'blue-rhinestone-jorts':         'distant-white-tee',
    'brown-rhinestone-jorts':        'distant-white-tee',
    'black-rhinestone-jort':         'distant-black-tee',
    'grey-rhinestone-jorts':         'distant-white-tee',
    'purple-jeans':                  'distant-white-tee',
    'blue-jeans':                    'distant-white-tee',
    'black-jeans':                   'distant-black-tee',
    'distant-purple-jeans':          'distant-white-tee',
  };

  const LABELS = {
    'black-distant-hoodie':          'Add To Your Order & Get 15% Off',
    'pink-distant-hoodie':           'Add To Your Order & Get 15% Off',
    'blue-distant-hoodie':           'Add To Your Order & Get 15% Off',
    'purple-distant-hoodie':         'Add To Your Order & Get 15% Off',
    'black-distant-sweatpants':      'Add To Your Order & Get 15% Off',
    'pink-distant-sweatpants':       'Add To Your Order & Get 15% Off',
    'blue-distant-sweatpants':       'Add To Your Order & Get 15% Off',
    'purple-distant-sweatpants':     'Add To Your Order & Get 15% Off',
    'black-distant-sweatpants-copy': 'Add To Your Order & Get 15% Off',
    'purple-distant-sweatpants-copy':'Add To Your Order & Get 15% Off',
    'blue-distant-sweatpants-copy':  'Add To Your Order & Get 15% Off',
    'pink-distant-sweats':           'Add To Your Order & Get 15% Off',
    'black-tracksuit':               'Add To Your Order & Get 15% Off',
  };

  const DEFAULT_LABEL  = 'Add To Your Order';
  const DISCOUNT_CODE  = 'WELCOME15';
  const DISCOUNT_TEXT  = '15% OFF';

  const INJECT_BEFORE_SELECTOR = '.cart-modal-buttons';
  const TOTAL_PRICE_SELECTOR   = '.cart-total';

  let injected = false;
  let addedKey = null;
  let isRunning = false;

  function refreshCartTotal() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const el = document.querySelector(TOTAL_PRICE_SELECTOR);
        if (!el) return;
        const currency = el.textContent.trim().split(' ').pop();
        el.textContent = '$' + (cart.total_price / 100).toFixed(2) + ' ' + currency;
      });
  }

  function showDiscountPopup() {
    document.getElementById('ds-discount-popup')?.remove();

    const popup = document.createElement('div');
    popup.id = 'ds-discount-popup';
    popup.innerHTML = `
      <div style="
        position:fixed;bottom:80px;left:50%;transform:translateX(-50%);
        background:#fff;border-radius:12px;padding:24px 20px;
        box-shadow:0 8px 32px rgba(0,0,0,0.18);
        z-index:99999;width:280px;text-align:center;
        border:1px solid rgba(0,0,0,0.08);
      ">
        <button id="ds-popup-close" style="
          position:absolute;top:10px;right:12px;
          background:none;border:none;cursor:pointer;
          font-size:18px;color:#999;line-height:1;
        ">×</button>
        <p style="font-size:13px;color:#888;margin:0 0 6px;">You got</p>
        <p style="font-size:24px;font-weight:700;margin:0 0 4px;">${DISCOUNT_TEXT} your order</p>
        <p style="font-size:12px;color:#888;margin:0 0 16px;">Apply discount and go to checkout?</p>
        <div style="display:flex;gap:8px;justify-content:center;">
          <a href="/checkout?discount=${DISCOUNT_CODE}" style="
            background:#000;color:#fff;border:none;border-radius:6px;
            padding:10px 20px;font-size:13px;font-weight:600;
            cursor:pointer;text-decoration:none;display:inline-block;
          ">Yes, please</a>
          <button id="ds-popup-no" style="
            background:none;color:#333;border:1.5px solid rgba(0,0,0,0.2);
            border-radius:6px;padding:10px 20px;font-size:13px;
            font-weight:500;cursor:pointer;
          ">No</button>
        </div>
      </div>
    `;

    document.body.appendChild(popup);
    document.getElementById('ds-popup-close').addEventListener('click', () => popup.remove());
    document.getElementById('ds-popup-no').addEventListener('click', () => popup.remove());
  }

  async function run() {
    if (isRunning) return;
    isRunning = true;

    try {
      const target = document.querySelector(INJECT_BEFORE_SELECTOR);
      if (!target) { isRunning = false; return; }

      document.getElementById('ds-upsell')?.remove();
      injected = false;
      addedKey = null;

      const cart = await fetch('/cart.js').then(r => r.json());
      const trigger = cart.items.find(i => RULES[i.handle]);
      if (!trigger) { isRunning = false; return; }

      const upsellHandle = RULES[trigger.handle];
      const alreadyInCart = cart.items.some(i => i.handle === upsellHandle);
      if (alreadyInCart) { isRunning = false; return; }

      const product = await fetch(`/products/${upsellHandle}.js`).then(r => r.json());
      if (!product) { isRunning = false; return; }

      const preferredVariant =
        product.variants.find(v => v.title === trigger.variant_title)
        || product.variants[0];

      const label = LABELS[trigger.handle] || DEFAULT_LABEL;

      const block = document.createElement('div');
      block.id = 'ds-upsell';
      block.innerHTML = `
        <div style="padding:14px 16px;border-top:1px solid rgba(0,0,0,0.08);margin-bottom:12px;">
          <p style="font-size:13px;font-weight:600;margin:0 0 10px;letter-spacing:.04em;text-transform:uppercase;">
            ${label}
          </p>
          <div id="ds-upsell-card" style="
            display:flex;align-items:center;gap:12px;
            border:1.5px solid rgba(0,0,0,0.12);
            border-radius:8px;padding:10px;cursor:pointer;
            transition:border-color .15s;
          ">
            <div id="ds-upsell-check" style="
              width:20px;height:20px;flex-shrink:0;
              border:1.5px solid rgba(0,0,0,0.25);border-radius:4px;
              display:flex;align-items:center;justify-content:center;
              transition:all .15s;
            ">
              <svg id="ds-check-icon" viewBox="0 0 11 8" style="display:none;width:11px;height:8px;">
                <path d="M1 4l3 3 6-6" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              </svg>
            </div>
            <img src="${product.featured_image}" alt="${product.title}"
              style="width:52px;height:52px;object-fit:cover;border-radius:6px;flex-shrink:0;">
            <div style="flex:1;min-width:0;">
              <p style="font-size:13px;font-weight:500;margin:0 0 5px;
                white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                ${product.title}
              </p>
              <div style="display:flex;align-items:center;gap:8px;">
                <select id="ds-upsell-select" style="
                  font-size:12px;border:1px solid rgba(0,0,0,0.2);
                  border-radius:4px;padding:2px 18px 2px 5px;
                  background:none;appearance:none;-webkit-appearance:none;
                  background-image:url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%228%22 height=%225%22%3E%3Cpath d=%22M1 1l3 3 3-3%22 stroke=%22%23666%22 fill=%22none%22 stroke-width=%221.2%22/%3E%3C/svg%3E');
                  background-repeat:no-repeat;background-position:right 4px center;
                  cursor:pointer;
                ">
                  ${product.variants.map(v =>
                    `<option value="${v.id}" data-price="${v.price}"
                      ${v.id === preferredVariant.id ? 'selected' : ''}>
                      ${v.title}
                    </option>`
                  ).join('')}
                </select>
                <span id="ds-upsell-price" style="font-size:13px;font-weight:500;">
                  $${(preferredVariant.price / 100).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
      `;

      const totalRow = document.querySelector('.h6.leading-none');
      const insertBefore = totalRow || document.querySelector(INJECT_BEFORE_SELECTOR);

      if (document.getElementById('ds-upsell')) { isRunning = false; return; }
      insertBefore.parentNode.insertBefore(block, insertBefore);
      injected = true;

      const select = document.getElementById('ds-upsell-select');
      const priceEl = document.getElementById('ds-upsell-price');

      select.addEventListener('change', async (e) => {
        e.stopPropagation();
        const opt = select.options[select.selectedIndex];
        priceEl.textContent = '$' + (opt.dataset.price / 100).toFixed(2);
        if (addedKey) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: addedKey, quantity: 0 })
          });
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: select.value, quantity: 1 })
          }).then(r => r.json());
          addedKey = res.key;
          refreshCartTotal();
        }
      });

      document.getElementById('ds-upsell-card').addEventListener('click', async (e) => {
        if (e.target === select || e.target.tagName === 'OPTION') return;
        if (!injected) return;

        const checkEl = document.getElementById('ds-upsell-check');
        const checkIcon = document.getElementById('ds-check-icon');
        const card = document.getElementById('ds-upsell-card');

        if (!addedKey) {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: select.value, quantity: 1 })
          }).then(r => r.json());
          addedKey = res.key;
          checkEl.style.background = '#000';
          checkEl.style.borderColor = '#000';
          checkIcon.style.display = 'block';
          card.style.borderColor = '#000';
          refreshCartTotal();
          if (LABELS[trigger.handle]) showDiscountPopup();
        } else {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: addedKey, quantity: 0 })
          });
          addedKey = null;
          checkEl.style.background = '';
          checkEl.style.borderColor = 'rgba(0,0,0,0.25)';
          checkIcon.style.display = 'none';
          card.style.borderColor = 'rgba(0,0,0,0.12)';
          refreshCartTotal();
          document.getElementById('ds-discount-popup')?.remove();
        }
      });

    } finally {
      isRunning = false;
    }
  }

  const observer = new MutationObserver(() => {
    if (isRunning) return;
    if (!document.querySelector(INJECT_BEFORE_SELECTOR)) return;
    if (document.getElementById('ds-upsell')) return;
    observer.disconnect();
    setTimeout(() => {
      run().finally(() => {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }, 250);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const result = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    if (url.includes('/cart/add') && !url.includes('ds-upsell')) {
      setTimeout(() => {
        if (!isRunning && !document.getElementById('ds-upsell')) {
          run();
        }
      }, 400);
    }
    return result;
  };

})();
// Cart trust bar + offer countdown
function dsInitCart() {
  const drawer = document.querySelector('.cart-drawer, cart-drawer, [id*="cart-drawer"]');
  if (!drawer) return;

  // Stars + trust text — inject after cart title
  if (!drawer.querySelector('#ds-trust-bar')) {
    const header = drawer.querySelector('.cart-drawer__header, .cart__header, h2, [class*="cart"][class*="title"]');
    if (header) {
      const trust = document.createElement('div');
      trust.id = 'ds-trust-bar';
      trust.innerHTML = '<span class="ds-stars">★★★★★</span><span>Trusted by 1,000+ customers</span>';
      header.after(trust);
    }
  }

  // Offer bar + countdown — inject before checkout button
  const btn = drawer.querySelector('[name="checkout"], .cart__checkout-button, button[class*="checkout"]');
  if (btn && !drawer.querySelector('#ds-offer-bar')) {
    const bar = document.createElement('div');
    bar.id = 'ds-offer-bar';
    bar.innerHTML = `
      <div class="ds-offer-text">40% off &bull; Free &amp; fast shipping</div>
  
    `;
    btn.parentElement.insertBefore(bar, btn);

    // Rename button
    btn.innerHTML = btn.innerHTML.replace(/checkout/gi, 'Claim Offer').replace(/check out/gi, 'Claim Offer');

    // Countdown
    let secs = 600;
    const el = document.getElementById('ds-cart-timer');
    const tick = () => {
      if (!el) return;
      const m = Math.floor(secs / 60);
      const s = secs % 60;
      el.textContent = `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
      if (secs > 0) { secs--; setTimeout(tick, 1000); }
    };
    tick();
  }
}

// Run on cart open
document.addEventListener('DOMContentLoaded', dsInitCart);
document.addEventListener('cart:open', dsInitCart);
document.addEventListener('drawer:open', dsInitCart);
// Also observe for drawer appearing
const obs = new MutationObserver(() => dsInitCart());
obs.observe(document.body, { childList: true, subtree: true });